import imagePub from "../../../images/ImagePub.jpg";
import arrow from "../../../images/arrowIntervention.png";
import BgPattern from "../../../images/BG-Pattern.png";
import NoImage from "../../../images/NoImage.jpg";
import NoProfile from "../../../images/profileImage.png";

import {useEffect, useState} from "react";
import {useMe} from "../../../hooks/useGetUser";
import {useDailyIntervention} from "../../../hooks/useInterventions";
import {simpleDate} from "../../../utils/date";
import {accountStatus, interventionStatus} from "../../../utils/constants";
import {Link} from "react-router-dom";
import StarIcon from "../../../images/icons/starIcon";
import ImageComponent from "../../components/shared/ImageComponent";
import {baseImageUrl} from "../../../services/AxiosInstance";
import Weather from "../../components/shared/Weather";
import InterventionItem from "../../components/offer/interventionItem";

import Loader from "../../components/shared/Loader";
import ListCardIntervention from "./listCardClient";
import CalendarIntervention from "./CalendarIntervention";
import PubList from "../../components/shared/PubList";

const PageMesInterventionsClient = () => {
  const [tabList, setTabList] = useState(true);
  const [history, setHistory] = useState(false);
  const [searchValue, setsearchValue] = useState("");

  const {data, isLoading: isMeLoading} = useMe();
  const today = new Date();

  const {interventions, isError, isLoading} = useDailyIntervention({
    size: 5,
    filter: {
      startDate: simpleDate(today),
      status: [
        interventionStatus.NEW,
        interventionStatus.PROCESSING,
        interventionStatus.REPORTED,
      ],
    },
    order: [["startDate", "ASC"]],
  });

  const [filter, SetFilter] = useState({
    size: 999,
    filter: {
      startDate: simpleDate(new Date("2021-01-01")),
      status: [
        interventionStatus.NEW,
        interventionStatus.PROCESSING,
        interventionStatus.REPORTED,
      ],
    },
    order: [["startDate", "DESC"]],
    search: "",
  });

  // useEffect(() => {
  //   if (!isMeLoading && data) {
  //     const newFilter = {status: [accountStatus.VALID]};

  //     SetFilter((prevFilter) => ({
  //       ...prevFilter,
  //       filter: newFilter,
  //       search: "",
  //     }));
  //   }
  // }, [data, isMeLoading]);

  if (isMeLoading) {
    return <Loader />;
  }
  return (
    <>
      <div className="w-full grid lg:grid-cols-4 gap-6 ">
        <div className="w-full col-span-3 flex flex-col  px-4 lg:!px-0 justify-start items-start gap-3">
          <div className="flex items-center w-full !mb-4">
            <div
              onClick={() => setTabList(true)}
              className={
                "cursor-pointer w-1/2 lg:w-1/4 flex items-center justify-center !p-3 gap-2 font-medium text-[15px] leading-4 border rounded-l-lg " +
                (tabList ? " bg-[#1A64B9] text-white" : " bg-white")
              }
            >
              <i className="fi fi-rr-list flex items-center"></i>
              Liste
            </div>
            <div
              onClick={() => setTabList(false)}
              className={
                " cursor-pointer w-1/2 lg:w-1/4 flex items-center justify-center !p-3 gap-2 font-medium text-[15px] leading-4 border rounded-r-lg " +
                (!tabList ? " bg-[#1A64B9] text-white" : " bg-white")
              }
            >
              <i className="fi fi-rr-calendar-lines flex items-center"></i>
              Calendrier
            </div>
          </div>

          {!!tabList ? (
            <>
              <div className="w-full flex-wrap-reverse flex justify-between items-center gap-2">
                <div className=" text-left font-bold text-[#19295C] text-2xl sm:leading-4 ">
                  {!history
                    ? "Mes interventions"
                    : "Historique des interventions"}
                </div>
                <div className="flex justify-end flex-1">
                  <div
                    onClick={() => {
                      if (!history) {
                        SetFilter((prev) => ({
                          ...prev,
                          filter: {
                            ...prev.filter,
                            status: [
                              interventionStatus.CANCELED,
                              interventionStatus.ENDED,
                            ],
                            startDate: simpleDate(new Date("2021-01-01")),
                          },
                          order: [["startDate", "DESC"]],
                        }));
                        setHistory(true);
                      } else {
                        SetFilter((prev) => ({
                          ...prev,
                          filter: {
                            ...prev.filter,
                            status: [
                              interventionStatus.NEW,
                              interventionStatus.PROCESSING,
                              interventionStatus.REPORTED,
                            ],
                            startDate: simpleDate(new Date("2021-01-01")),
                          },
                          order: [["startDate", "ASC"]],
                        }));
                        setHistory(false);
                      }
                    }}
                    className={`min-w-12  cursor-pointer rounded-lg flex justify-center gap-2 py-2 px-3 text-sm items-center ${
                      history
                        ? "bg-[#1A64B9] text-white"
                        : "bg-white text-[#1A64B9] !border !border-[#1A64B9]"
                    } `}
                  >
                    Historique
                    <i className="fi fi-rr-time-past flex items-center"></i>
                  </div>
                </div>
              </div>
              <div className="w-full  flex justify-start items-center gap-2">
                <div className="flex w-full  text-[#7E7E7E] items-center gap-2 bg-white rounded-[28px] text-sm p-3 ">
                  <i className="!ml-2  fi fi-rr-search flex justify-center items-center"></i>
                  <input
                    className="border-none flex-grow w-[90%] placeholder:text-[#7E7E7E] placeholder:text-[13px]  "
                    type="text"
                    placeholder="Rechercher une intervention..."
                    value={searchValue}
                    onChange={(e) => setsearchValue(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        SetFilter((prevFilter) => ({
                          ...prevFilter,
                          search: searchValue,
                        }));
                        // For debugging
                      }
                    }}
                  />
                  {!!searchValue && (
                    <i
                      class="fi fi-rr-cross-small flex items-center cursor-pointer"
                      onClick={() => {
                        setsearchValue("");
                        SetFilter((prevFilter) => ({
                          ...prevFilter,
                          search: "",
                        }));
                      }}
                    ></i>
                  )}
                </div>
              </div>

              <div className="w-full flex flex-col gap-4">
                <ListCardIntervention filter={filter} />
              </div>
            </>
          ) : (
            <div className="w-full flex flex-col gap-4">
              <CalendarIntervention filter={filter} />
            </div>
          )}
        </div>

        <div className="w-full hidden  h-fit    pb-4  lg:flex flex-col gap-4 self-start  ">
          <Weather />
          <div className="w-full rounded-2xl  bg-white flex flex-col text-[#19295C] font-bold text-xl ">
            <div className="w-full flex items-start justify-between p-3">
              <span className="font-semibold text-lg">
                Interventions à venir
              </span>
              <Link to={"/interventions"}>
                <img src={arrow} className="cursor-pointer" alt="" />
              </Link>
            </div>
            {isLoading && <Loader />}
            {isError && (
              <div className="p-4 text-red text-center">
                "Oups ! Un problème est survenu lors de la récupération des
                données. Veuillez vérifier votre connexion ou réessayer plus
                tard."
              </div>
            )}
            {interventions && !!interventions.length ? (
              interventions.map((intervention) => (
                <InterventionItem
                  key={intervention.id}
                  intervention={intervention}
                  className={"border-b border-solid border-[#D6E2EF] "}
                />
              ))
            ) : (
              <div className="text-center py-3 font-medium text-base text-[#7e7e7e]">
                Pas d'interventions.
              </div>
            )}
          </div>

          <PubList />
        </div>
      </div>
    </>
  );
};

export default PageMesInterventionsClient;
